import type { FaireProductEntity } from "../../entity_types/product";

export const p_43haaansxw: FaireProductEntity = {
  token: "p_43haaansxw",
  type: "product",
  name: "Italian Charm Link Watch (Analog)",
  brandToken: "b_kqast86cfn",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/bee68f362e21b7eaf194d593239937e126b50a793119f3ab8377539b0a3f3f1f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2552603230ce0ecae6efa6acc188bdbebc785b6524930fc8642e7346f615f578.jpeg",
    "https://cdn.faire.com/fastly/e59dea3334498f93327ad3d2061fe975b63fc79c125f563dc7250ccd401be443.jpeg",
    "https://cdn.faire.com/fastly/44302269c8e26a1ef104b9c8e8645f15bc18d7779c243207ffd16cf9a8681bfb.jpeg",
    "https://cdn.faire.com/fastly/3aa1389bd86d6700b8028861501ec6d2e3b135554fa325d3dde8d5ef978bc37b.jpeg",
    "https://cdn.faire.com/fastly/42a9ee0e74bae2160bcaef546ec1a4cff03b8255919056b59fd50e310d2dabef.jpeg",
    "https://cdn.faire.com/fastly/ad93f3950fc113713df2ad10b00ec5a01bf7d910173d354091f4b5ea553959aa.jpeg",
    "https://cdn.faire.com/fastly/2b49832dc1913170c0b0de26d8538e2e18946d37677fd9efd817b6345a0a65b5.jpeg",
    "https://cdn.faire.com/fastly/cf3029283fc5f5f591fcbb54a5458e0982a3fd1d8bb06f588a91dddcecdcb38d.jpeg",
    "https://cdn.faire.com/fastly/9ba70b87e1e6adbc4bb8b9a1978ff6239b5e4b96ef7fc4c0fbd2a95ef6d1eae0.jpeg",
    "https://cdn.faire.com/fastly/40c00ae90526ddca65beab22e1535841b395a6e93ec98f90c9579be739ba1bed.jpeg",
    "https://cdn.faire.com/fastly/c7f0825dae72f496c2e8454878c66cf1bd5da9a469f55be7232807ea6baca629.jpeg",
  ],
  priceDollars: 10,
  description:
    "* Italian charm watch\n* Analog time display\n* Includes 15 blank links attached to the watch for a universal fit\n* Watch face color options:&nbsp; Black, Silver, Pink, Purple, Aqua, and Green\n* High-quality movement components made in Japan\n* Each Italian charm link measures 9mm tall and 10mm wide\n* Add or remove charms to completely customize your Italian charm watch strap\n\nPerfect for jewelry stores, men's and women's fashion boutiques, and gift shops",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:38.525Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
